export default __webpack_public_path__ + "static/media/bg01.63b10dd0.jpg";